import React, { useEffect } from "react";
import styles from "./style.module.css";
import sectionStyles from "../sectionStyles.module.css";
import { TEXTS } from "../../static/texts";
import { IMAGES } from "../../static/assets/images";

export const About = ({ pageTop }) => {
  useEffect(() => {
    pageTop.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [pageTop]);

  return (
    <>
      <div className={styles.bannerContainer}>
        <h1 className={sectionStyles.titleText}>{TEXTS.NOSOTROS_TITLE}</h1>
      </div>
      <div className={sectionStyles.redContainer}>
        <p className={styles.flavorText}>{TEXTS.NOSOTROS_FLAVOR_1}</p>
        <p className={styles.flavorText}>{TEXTS.NOSOTROS_FLAVOR_2}</p>
      </div>
      <div className={sectionStyles.blackContainer}>
        <div className={styles.creatorRow}>
          <img
            src={IMAGES.GIORDANO}
            className={styles.creatorImage}
            alt="Giordano Bruno Pinto Campos"
          />
          <div className={styles.textContainer}>
            <h3 className={styles.creatorTitle}>{TEXTS.GIORDANO_TITLE}</h3>
            <p className={styles.creatorDescription}>{TEXTS.GIORDANO_TEXT}</p>
          </div>
        </div>
        <div className={sectionStyles.separator} />
        <div className={styles.sergioRow}>
          <img
            src={IMAGES.SERGIO}
            className={styles.creatorImage}
            alt="Sergio Méndez Tapia"
          />
          <div className={styles.textContainer}>
            <h3 className={styles.creatorTitle}>{TEXTS.SERGIO_TITLE}</h3>
            <p className={styles.creatorDescription}>{TEXTS.SERGIO_TEXT}</p>
          </div>
        </div>
        <div className={sectionStyles.separator} />
        <div className={styles.creatorRow}>
          <img
            src={IMAGES.JOSE}
            className={styles.creatorImage}
            alt="Jose Miguel Heras"
          />
          <div className={styles.textContainer}>
            <h3 className={styles.creatorTitle}>{TEXTS.JOSE_TITLE}</h3>
            <p className={styles.creatorDescription}>{TEXTS.JOSE_TEXT}</p>
          </div>
        </div>
      </div>
    </>
  );
};
